import { render, staticRenderFns } from "./riskOccasion.vue?vue&type=template&id=3e2c422b"
import script from "./riskOccasion.vue?vue&type=script&lang=js"
export * from "./riskOccasion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2c422b')) {
      api.createRecord('3e2c422b', component.options)
    } else {
      api.reload('3e2c422b', component.options)
    }
    module.hot.accept("./riskOccasion.vue?vue&type=template&id=3e2c422b", function () {
      api.rerender('3e2c422b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskOccasion.vue"
export default component.exports